import React, { ComponentType } from 'react';
import { ViewStyle, I18nManager } from 'react-native';

const withRTLFlip = <P extends object>(Component: ComponentType<P>): ComponentType<P & { style: ViewStyle }> => ({ style, ...props }) =>
    {
        return <Component {...props as P} style={[style, {transform: [{scaleX: I18nManager.isRTL ? -1 : 1}]}]} />;
    }

export default withRTLFlip;
